import { styled } from "@linaria/react"
import { observer } from "mobx-react-lite"

import { UserLight } from "@/icons/Icons.ts"
import * as textStyles from "@/styles/textStyles.ts"

export interface UserToUserChatNotificationPaneProps {
  talkingToOtherUsers: string[] | null
}

export const UserToUserChatNotificationPane = observer(({ talkingToOtherUsers }: UserToUserChatNotificationPaneProps) => {
  return (
    <Container>
      <InfoIcon />
      <NotificationText>
        You are now chatting with {talkingToOtherUsers?.join(", ") || "another user"}.
        The AI will only respond when you mention it directly using <strong>@agent</strong>.
      </NotificationText>
    </Container>
  )
})

const Container = styled.div`
`

const NotificationText = styled.span`
  ${textStyles.smallFontSize};

  color: var(--secondary-text-color);
`

const InfoIcon = styled(UserLight)`
  position: relative;
  top: 3px;

  width: 16px;
  height: 16px;
  margin-right: 4px;

  color: var(--secondary-text-color);
`
